/**
 * tema.js — claro, oscuro o el del sistema.
 *
 * Tres estados y no dos. Un interruptor de dos posiciones obliga a
 * elegir, y quien tiene el sistema configurado para cambiar solo al
 * anochecer pierde ese comportamiento en cuanto toca el control. Por eso
 * «automático» es un estado explícito y además el predeterminado.
 *
 * La preferencia se guarda en el navegador, no en la base: es de este
 * equipo, no de la cuenta. La misma persona puede querer oscuro en la
 * oficina y claro en el celular al sol.
 */

const CLAVE = "wifimex-tema";

/** Lo que la persona eligió: "auto" | "claro" | "oscuro". */
export function temaGuardado() {
  try {
    const v = localStorage.getItem(CLAVE);
    return v === "claro" || v === "oscuro" ? v : "auto";
  } catch {
    // Navegación privada o almacenamiento bloqueado: no es motivo para
    // que la app falle, simplemente no se recuerda entre sesiones.
    return "auto";
  }
}

/**
 * Aplica el tema al documento.
 *
 * En «auto» se QUITA el atributo en vez de escribir uno: así manda la
 * media query `prefers-color-scheme` de tokens.css, que sigue al sistema
 * en vivo — si el sistema cambia al anochecer, la app cambia con él sin
 * recargar.
 */
export function aplicarTema(tema) {
  const raiz = document.documentElement;
  if (tema === "auto") {
    raiz.removeAttribute("data-tema");
  } else {
    raiz.setAttribute("data-tema", tema);
  }
}

export function guardarTema(tema) {
  try {
    if (tema === "auto") localStorage.removeItem(CLAVE);
    else localStorage.setItem(CLAVE, tema);
  } catch {
    // Ver arriba: no poder recordarlo no debe impedir aplicarlo ahora.
  }
  aplicarTema(tema);
}

/** Se llama una vez al arrancar, antes de pintar. */
export function iniciarTema() {
  aplicarTema(temaGuardado());
}
